import React from 'react';
import { PokemonContext } from '../context/pokemonContext';
import { colors } from "../colors/cardColor";
import Chips from "./Chips";

const PokemonImageCard = () => {

    const { pokemon } = React.useContext(PokemonContext);

    return (
        <div 
            className="pokemon-name-container d-flex flex-column"
            style={{
                backgroundColor: colors[pokemon.types.length>0 ? 
                    pokemon.types[0].type.name : 
                    ''
                ]
            }}
        >

            <div className="pokemon-img-container">
                <div className="img-bg"></div>
                <img 
                    src={pokemon.imgUrl} 
                    alt={pokemon.name}
                    className="pokemon-img"
                />
            </div>

            <hr />

            <div className="text-center">
                <h1 className="pokemon-name">{pokemon.name}</h1>
                <Chips types={pokemon.types} />
            </div>
        </div>
    );
}

export default PokemonImageCard;